/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Toggle_Edit_ModeInputs */



/**
* | output |
* | --- |
* | "Toggle Edit Mode" |
*
* @param {Shortcut_Keys_Name_Toggle_Edit_ModeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_toggle_edit_mode = /** @type {((inputs?: Shortcut_Keys_Name_Toggle_Edit_ModeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Toggle_Edit_ModeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Basculer le mode edition")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bearbeitungsmodus umschalten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attiva/disattiva la modalità di modifica")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переключить режим редактирования")
	if (locale === "es") return /** @type {LocalizedString} */ ("Activar o desactivar el modo de edición")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("切换编辑模式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("編集モードを切り替える")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संपादन मोड को चालू/बंद करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alternar modo de edição")
	return /** @type {LocalizedString} */ ("Toggle Edit Mode")
});